import { supabase } from '../../lib/supabase/client'
import { TABLES } from '../../lib/supabase/contracts.full'
import type { PreviousSet, PreviousValueContext } from './previousValues'
import { findPreviousComparableSet } from './previousValues'

export async function getPreviousValues(input: {
  athleteId: string
  context: PreviousValueContext
}) {
  let sessionsQuery = supabase
    .from(TABLES.workoutSessions)
    .select('id,source_day_id,source_day_index,ended_at')
    .eq('athlete_id', input.athleteId)
    .in('status', ['completed', 'completed_early'])
    .order('ended_at', { ascending: false })
    .limit(30)

  if (input.context.sourceDayId) sessionsQuery = sessionsQuery.eq('source_day_id', input.context.sourceDayId)
  else if (input.context.sourceDayIndex != null) sessionsQuery = sessionsQuery.eq('source_day_index', input.context.sourceDayIndex)

  const { data: sessions, error: sessionsError } = await sessionsQuery
  if (sessionsError) throw sessionsError
  if (!sessions?.length) return null

  const sessionById = new Map(sessions.map((session) => [session.id, session]))
  const { data: sets, error: setsError } = await supabase
    .from(TABLES.workoutSets)
    .select('session_id,exercise_id,exercise_name_snapshot,set_type,weight_kg,reps,duration_seconds,distance_m,completed_at,status')
    .in('session_id', sessions.map((session) => session.id))
    .eq('status', 'completed')
    .order('completed_at', { ascending: false })

  if (setsError) throw setsError

  const history: PreviousSet[] = (sets ?? []).map((set) => {
    const session = sessionById.get(set.session_id)
    return {
      exercise_id: set.exercise_id,
      exercise_name_snapshot: set.exercise_name_snapshot,
      set_type: set.set_type,
      weight: set.weight_kg == null ? null : Number(set.weight_kg),
      reps: set.reps == null ? null : Number(set.reps),
      duration_seconds: set.duration_seconds,
      distance_meters: set.distance_m == null ? null : Number(set.distance_m),
      completed_at: set.completed_at,
      source_day_id: session?.source_day_id ?? null,
      source_day_index: session?.source_day_index ?? null,
    }
  })

  return findPreviousComparableSet(history, input.context)
}
